var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:{ 'delayed': _vm.delayed }},[_vm._v(_vm._s(_vm.departureTime)+" - "+_vm._s(_vm.station.name))])}
var staticRenderFns = []

export { render, staticRenderFns }